
export const ConditionalComponentWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;
